import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { PersonHasEducationLocationItem, PersonHasEducationLocation } from '../models';

export class PersonHasEducationLocationApi extends ApiModule {
  protected endpoint = '/person-has-education-location';

  public async pagePersonHasEducationLocations(params: any) {
    return this.api.post<PaginatedResponseData<PersonHasEducationLocationItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadPersonHasEducationLocationDetails(id: number) {
    return this.api.get<PersonHasEducationLocation>(`${this.endpoint}?id=${id}`);
  }

  public savePersonHasEducationLocation(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deletePersonHasEducationLocation(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
}
